import { create } from 'zustand';

/**
 * 채팅 우측 **상세보기 패널**의 열림 상태 (chat-detail-panel).
 *
 * ⚠ 옛 참가자 바(chatSidebarStore, key `chat.sidebar.collapsed`)와 **키를 나눈다**.
 *   그 키에 저장된 값은 "참가자 바를 펼쳐 뒀다" 는 뜻이라, 새 패널이 그걸 물려받으면
 *   예전에 바를 한 번 펼쳐 본 사람에게는 상세보기가 **처음부터 열린 채로** 뜬다.
 *   두 값은 같은 것을 가리키지 않으므로 따로 둔다.
 *
 * 기본은 **닫힘** — 채팅에 들어가면 대화가 먼저 보여야 하고, 정보는 찾을 때 연다.
 * 사용자가 연 뒤의 선택은 localStorage 로 남긴다(다음에 그대로).
 */
const LS_OPEN = 'chat.detail.open';

function readOpen(): boolean {
  try {
    // 'true' 로 저장된 경우에만 열림. 미저장·오류는 닫힘(기본).
    return localStorage.getItem(LS_OPEN) === 'true';
  } catch {
    return false;
  }
}

function persist(v: boolean): void {
  try {
    localStorage.setItem(LS_OPEN, String(v));
  } catch {
    /* localStorage 비활성(프라이빗 모드 등) — 세션 내 동작은 유지 */
  }
}

interface ChatDetailPanelState {
  open: boolean;
  toggle: () => void;
  setOpen: (v: boolean) => void;
}

export const useChatDetailPanelStore = create<ChatDetailPanelState>((set) => ({
  open: readOpen(),
  toggle: () => set((s) => {
    const next = !s.open;
    persist(next);
    return { open: next };
  }),
  setOpen: (v) => { persist(v); set({ open: v }); },
}));
